export default "__VITE_ASSET__698e1e6b__"